import { computed } from 'vue';
import { getCroppedMediaUrl } from '../../utils/component-lib.esm19.js';

//
var script = {
  props: {
    canLoadImages: Boolean,
    mediaItem: {
      type: Object,
      required: true
    },
    alt: String
  },
  setup(props) {
    const imageSources = computed(() => {
      const {
        mediaItem,
        canLoadImages
      } = props;
      if (!canLoadImages) {
        return {};
      }
      const imageSrc = getCroppedMediaUrl(mediaItem.url, 650);
      const imageHighResSrc = getCroppedMediaUrl(mediaItem.url, 1300);
      return {
        src: imageSrc,
        srcset: `${imageSrc} 650w, ${imageHighResSrc} 1300w`,
        sizes: '(min-width: 650px) 650w, 100vw'
      };
    });
    return {
      imageSources
    };
  }
};
export { script as default };